import { styled } from "@lib/components";
import { Link } from "../../../components/router/Link";

export const AuthHeading = styled("h1")`
	font-size: 24px;
	font-weight: 700;
	color: #0f172a;
	margin: 0 0 4px;
`;

export const AuthSubheading = styled("p")`
	font-size: 14px;
	color: #64748b;
	margin: 0 0 24px;
`;

export const FormField = styled("div")`
	margin-bottom: 16px;

	&:last-of-type {
		margin-bottom: 0;
	}
`;

export const FormLabel = styled("label")`
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #334155;
	margin-bottom: 4px;
`;

export const FormLabelRow = styled("div")`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 4px;
`;

export const FormInput = styled("input")`
	width: 100%;
	padding: 8px 12px;
	font-size: 14px;
	color: #0f172a;
	background: white;
	border: 1px solid ${(props) => props.theme.colors.primary};
	border-radius: 6px;
	transition: border-color 0.15s, box-shadow 0.15s;

	&::placeholder {
		color: #94a3b8;
	}

	&:focus {
		outline: none;
		border-color: ${(props) => props.theme.colors.primary};
		box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary}33;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export const PasswordField = styled("div")`
	position: relative;
	width: 100%;

	${FormInput} {
		padding-right: 40px;
	}
`;

export const ForgotLink = styled(Link)`
	font-size: 12px;
	color: ${(props) => props.theme.colors.primary};
	text-decoration: none;

	&:hover {
		opacity: 0.85;
	}
`;

export const SubmitButton = styled("button")`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: 100%;
	margin-top: 16px;
	padding: 10px 16px;
	font-size: 16px;
	font-weight: 500;
	color: white;
	background: ${(props) => props.theme.colors.primary};
	border: none;
	border-radius: 6px;
	cursor: pointer;
	transition: opacity 0.15s;

	&:hover:not(:disabled) {
		opacity: 0.9;
	}

	&:focus {
		outline: none;
		box-shadow: 0 0 0 2px white, 0 0 0 4px ${(props) => props.theme.colors.primary};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const FooterLinks = styled("div")`
	margin-top: 24px;
	text-align: center;
	font-size: 14px;
	color: #64748b;

	p {
		margin: 0 0 8px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	a {
		color: ${(props) => props.theme.colors.primary};
		text-decoration: none;

		&:hover {
			opacity: 0.85;
		}
	}
`;

export const TestEnvLabel = styled("div")`
	margin-top: 16px;
	text-align: center;
	font-size: 14px;
	color: #64748b;
`;

export const InfoText = styled("p")`
	margin: 0 0 16px;
	font-size: 14px;
	line-height: 1.5;
	color: #64748b;
	text-align: center;
`;

export const TermsField = styled("label")`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	margin-bottom: 16px;
	font-size: 14px;
	line-height: 1.5;
	color: #334155;
	cursor: pointer;

	input {
		width: 16px;
		height: 16px;
		margin-top: 2px;
		flex-shrink: 0;
		accent-color: ${(props) => props.theme.colors.primary};
	}

	a {
		color: ${(props) => props.theme.colors.primary};
	}
`;
